"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StableLiquidityMetaPool = void 0;
const types_1 = require("../types");
const stable_1 = require("./stable");
class StableLiquidityMetaPool extends stable_1.StableLiquidityPool {
    constructor(lpToken, metaPooledCurrencies, pooledCurrencies, rewardAmountsYearly, tradingFee, poolId, amplificationCoefficient, totalSupply, basePool // Contains base pool object.
    ) {
        super(types_1.PoolType.STABLE_META, lpToken, metaPooledCurrencies, pooledCurrencies, rewardAmountsYearly, tradingFee, poolId, amplificationCoefficient, totalSupply);
        this.basePool = basePool;
    }
}
exports.StableLiquidityMetaPool = StableLiquidityMetaPool;
//# sourceMappingURL=stable-meta.js.map